export default {
  'alert:btn': 'OK',
  'alert:no-iin-title': 'Если у Вашего ребенка нет <br> ИИН, обратитесь в ЦОН <br> по месту прописки.',
  'alert:no-iin-text': 'Подробнее о получении ИИН для ребенка можно узнать на сайте <a class="egov" href="https://egov.kz/cms/ru/articles/child/2Fiin_of_child" target="_blank">egov.kz.</a>',
  'alert:your-iin-title': ' Вы ввели свой ИИН',
  'alert:your-iin-text': 'Введите ИИН вашего ребенка',
  'alert:your-phone-title': ' {0}, вы указали свой номер телефона',
  'alert:your-phone-text': 'Укажите номер телефона {0}',
  'alert:iin-exist-title': 'Указанный ИИН принадлежит другому Клиенту Kaspi.',
  'alert:iin-exist-text': 'Введите ИИН вашего ребенка',
  'alert:phone-exist-title': 'Указанный номер принадлежит другому Клиенту Kaspi.',
  'alert:phone-exist-text': 'Введите номер вашего ребенка',
  'alert:validation-title': 'Укажите номер ребенка',
  'alert:validation-text': 'Чтобы мы могли сформировать заявление на оформление Kaspi&nbsp;Gold',
  'alert:clear': 'Понятно',
  'alert:min-age': 'Kaspi Gold для ребенка</br> можно оформить только</br> с 6 лет',
  'alert:max-age': '{0} может</br> самостоятельно</br>оформить Kaspi&nbsp;Gold</br> в своем приложении Kaspi.kz',
  'alert:has-gold': '{0} уже является держателем Kaspi&nbsp;Gold&nbsp;для&nbsp;ребенка',
  'alert:re-release': 'Перевыпустить',
  'alert:get-card': 'Получить карту',
  'alert:cancel': 'Отмена'
}
